export default "<div [innerHTML]=\"('<style>' + item.css + '</style>' + item.html) | safe:'html'\"></div>\n"